<template>
    <div class="section col_w_3">
        <div class="section_wrap">
            <h6 class="--blue70 mb20">{{ $t('my.options.title') }}</h6>
            <div class="option_container">
                <div class="txt_bold option_title">{{$t('lang.language')}}</div>
                <ul class="circle_radio">
                    <li>
                        <input type="radio" id="language_ko" name="language" v-model="langProps.value" value="ko-kr"
                               @click="checkCurrentValue('ko-kr')">
                        <label for="language_ko" class="txt_bold pointer"><span></span>한국어</label>
                    </li>
                  <li>
                    <input type="radio" id="language_en" name="language" v-model="langProps.value" value="en"
                           @click="checkCurrentValue('en')">
                    <label for="language_en" class="txt_bold pointer"><span></span>English</label>
                  </li>
                  <!--                  TODO: 중국어 운영 배포시 URL 체크 삭제-->
                  <li v-show="urlCheck">
                    <input type="radio" id="language_zh" name="language" v-model="langProps.value" value="zh"
                           @click="checkCurrentValue('zh')">
                    <label for="language_zh" class="txt_bold pointer"><span></span>中文 (繁體)</label>
                  </li>
                  <!--                  TODO: 체코어 운영 배포시 URL 체크 삭제-->
                  <li v-show="urlCheck">
                    <input type="radio" id="language_cs" name="language" v-model="langProps.value" value="cs"
                           @click="checkCurrentValue('cs')">
                    <label for="language_cs" class="txt_bold pointer"><span></span>čeština</label>
                  </li>
                </ul>
            </div>
            <div class="option_container">
                <div class="txt_bold option_title">{{$t('my.options.unit')}}</div>
                <ul class="circle_radio">
                    <li>
                        <input type="radio" id="imperial" name="length" value="imperial" v-model="unitProps.value"
                               @click="changeUnits('imperial' , unitProps.value)">
                        <label for="imperial"
                               class="txt_bold pointer"><span></span>{{$t('my.options.imperial')}}</label>
                    </li>
                    <li>
                        <input type="radio" id="metric" name="length" value="metric" v-model="unitProps.value"
                               @click="changeUnits('metric' , unitProps.value)">
                        <label for="metric" class="txt_bold pointer"><span></span>{{$t('my.options.metric')}}</label>
                    </li>
                </ul>
            </div>
            <div class="option_container">
                <div class="txt_bold option_title">{{$t('notice.name')}} ({{computedDesc}})</div>
                <ul class="circle_radio">
                    <li>
                        <input type="radio" id="allow" name="notice" value="granted" v-model="noticeProps.value"
                               :disabled="noticeProps.value === 'default' || noticeProps.value === 'denied' || noticeProps.value === 'notSupported'"
                               style="cursor: unset">
                        <label for="allow" class="txt_bold" style="color: var(--grey60);"><span style="cursor: unset"></span>{{$t('notice.status.allow')}}</label>
                    </li>
                    <li>
                        <input type="radio" id="block" name="notice" value="denied" v-model="noticeProps.value"
                               :disabled="noticeProps.value === 'default' || noticeProps.value === 'granted' || noticeProps.value === 'notSupported'"
                               >
                        <label for="block" class="txt_bold" style="color: var(--grey40);"><span style="cursor: unset"></span>{{$t('notice.status.block')}}</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapActions} from "vuex";

    export default {
      name: 'Options',
      props: ['langProps', 'unitProps', 'noticeProps'],
      // TODO: 중국어 운영 배포시 URL 체크 삭제
      data: () => {
        return {
          urlCheck: !window.location.href.includes('https://manager.rebless.clinic'),
        }
      },
      methods: {
        ...mapActions(['regenRootKey']),
        // 현재 언어와 설정하고자하는 언어가 같지는 않은지
        checkCurrentValue(lang) {
          if (this.langProps.value === lang) {
            return
          } else {
            this.checkVideoCalling(event, lang);
          }
        },
        // 진행중인 화상통화가 있다면
        checkVideoCalling(event, lang) {
          if (this.$store.getters.getVideoCallOpen) {
            this.$modal.show('yes-or-no-modal', {
              questionType: 'lang_setting_during_video_call',
              function: this.changeLanguage,
              funcParam: lang,
              height: 300,
            });
            event.preventDefault();
          } else {
            this.changeLanguage(lang);
          }
        },
        changeLanguage(lang) {
          this.$emit('changeLanguage', lang);
          this.regenRootKey();

          this.$fbConf.CHANGE_LANG(lang);
        },
        changeUnits(length, weight) {
          this.$emit('changeUnits', length, weight);
        },
      },
      computed: {
        computedDesc() {
          const value = this.noticeProps.value;
          if (value === "granted") {
            return this.$t('notice.desc_granted');
          } else if (value === "notSupported") {
            return this.$t('notice.not_supported');
          } else if (value === "") {
            return this.$t('notice.desc_default');
          } else {
            return this.$t('notice.desc_denied');
          }
        }
      }
    }
</script>
<style lang="scss">
    .option_container {
        margin-bottom: 30px;

        .circle_radio {
          display: flex;
          width: 800px;
        }

        .option_title {
            margin-bottom: 20px;
        }

        ul {
            li {
                width: 200px;
            }
        }
    }
</style>